define('app-TravelPortal/logout/main',["./settings"], function (settings) {

    if ($(settings.container).length === 0) {
        return null;
    }

    return {
        run: function () {
            var sessionStartedInMinutes = 0;
            var countDownInSeconds = 59;
            var sessionExpiresInMinutes = 35;

            setInterval(timerIncrement, 60000); // 1 minute

            function timerIncrement() {
                sessionStartedInMinutes = sessionStartedInMinutes + 1;
                if (sessionStartedInMinutes === sessionExpiresInMinutes - 1) {
                    $(settings.logoutModal).modal("show");
                    $(settings.countDown).text(settings.countDown);
                    setInterval(setCountDown, 1000); // 1 second
                }

                if (sessionStartedInMinutes > sessionExpiresInMinutes - 1) {
                    $(settings.logoutModal).modal("hide");
                    redirect();
                }
            }

            function setCountDown() {
                countDownInSeconds = countDownInSeconds - 1;
                if (countDownInSeconds > 0) {
                    $(settings.countDown).text(countDownInSeconds);
                }
            }

            $(settings.closeButton).on("click", function () {
                $(settings.logoutModal).modal("hide");
            });

            function redirect() {
                if ($("#divHeaderBar #LogoImage").length) {
                    // Redirect to MySaga
                    window.location = window.origin + "/my/travel";
                } else {
                    //Redirect to MMB portal
                    window.location = window.origin + "/api/sitecore/Logout";
                }
            }

            $(settings.logoutModal).on("hidden.bs.modal", function () {
                $(settings.logoutModal).modal("hide");
            });
        }
    };
});
